import React, { useState, useContext, useEffect } from 'react'
import { ProfileLayout } from "../layout"
import css from "./tax.module.scss"
import { Input } from "../../../componentsV1/Input"
import { AuthContext } from '../../../context/auth'
import { updateCustomerApi, currentUserApi } from '../../../api'

export const TaxExempt = () => {
  const { width, setIsLoading, user, setUser, setNotification } = useContext(AuthContext)
  const [taxExempt, setTaxExempt] = useState(null)
  const [taxExemptNumber, setTaxExemptNumber] = useState("")
  const [isChanged, setIsChanged] = useState(false)


  useEffect(() => {
    if (user?.customer) {
      const { is_tax_exempt, tax_number } = user.customer;
      const fieldsChanged =
        is_tax_exempt !== taxExempt ||
        tax_number !== taxExemptNumber

      setIsChanged(fieldsChanged);
    }

  }, [user, taxExempt, taxExemptNumber])



  const fetchCurrentUser = () => {
    currentUserApi()
      .then(res => {
        if (res.data) {
          setUser(res.data)
          setIsLoading(false)
        }
      })
      .catch(() => {
        setIsLoading(false)
      })
  }



  const reset = () => {
    setIsChanged(false)
    setTaxExempt(user?.customer?.is_tax_exempt)
    setTaxExemptNumber(user?.customer?.tax_number)
  }


  useEffect(() => {
    if (!taxExempt) {
      setTaxExemptNumber("")
    }
  }, [taxExempt])


  useEffect(() => {
    if (user) {
      reset()
    }
  }, [user])



  const onSave = () => {
    setIsLoading(true)
    const data = {
      is_tax_exempt: taxExempt,
      tax_number: taxExemptNumber
    }
    updateCustomerApi(data).then(() => {
      fetchCurrentUser()
      setIsLoading(false)
      setNotification({
        type: 'success',
        message: 'Changes saved successfully!'
      })
    }).catch(() => {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Something went wrong, please try again!'
      })
    })
  }


  return (
    <ProfileLayout>
      <div className={css.wrapper}>
        <div className={css.header}>
          <h4>Tax Exempt</h4>
          {isChanged && <div className={css.headerBtnContainer}>
            <button className={`btn ${css.transparentBtn}`} onClick={() => {
              reset()
            }}>Cancel</button>
            <button className={`btn ${css.ctaBtn}`} disabled={taxExempt && !taxExemptNumber} onClick={onSave}>Save Changes</button>
          </div>
          }
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <h4>Is Your Organization Tax Exempt?</h4>
          <div className={css.inputWrapper}>
            <div className={css.inputContainer}>
              <div className={css.selectOption} style={{ backgroundColor: taxExempt === false ? '#F5F5F51A' : 'transparent' }}>
                <label class={css.containers}>
                  <input type="radio" checked={taxExempt === false} name="tax" value="false" onChange={(e) => setTaxExempt(false)} />
                  <span class={css.checkmark}></span>
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={css.inputContainer}>
              <div className={css.selectOption} style={{ backgroundColor: taxExempt ? '#F5F5F51A' : 'transparent' }}>
                <label class={css.containers}>
                  <input type="radio" checked={taxExempt} name="tax" value="true" onChange={(e) => setTaxExempt(true)} />
                  <span class={css.checkmark}></span>
                  <span>Yes</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {taxExempt && <div className={css.inputWrapper}>
          <div className={css.inputContainer}>
            <label htmlFor="Country">Tax Exempt Number</label>
            <Input type='text' placeholder='Tax Exempt Number' value={taxExemptNumber} onChange={(e) => setTaxExemptNumber(e.target.value)} />
          </div>
        </div>
        }
        {width < 1100 && isChanged && <div className={css.buttonContainer}>
          <button className={`btn ${css.ctaBtn}`} onClick={onSave}>Save Changes</button>
          <button className={`btn ${css.transparentBtn}`} onClick={reset}>Cancel</button>
        </div>
        }
      </div>
    </ProfileLayout>
  )
}